import { AgentCoreColor, CopilotStudioColor, Kubernetes, VM } from "@/icons"

import type { InventoryPlatformAi } from "@/domain/ai-inventory"
import type { IconProps } from "@/icons"

// An agent platform in the product's colors
const AGENT_PLATFORM_ICONS: Record<InventoryPlatformAi, React.FC<IconProps>> = {
  AGENTCORE: AgentCoreColor,
  COPILOT_STUDIO: CopilotStudioColor,
  KUBERNETES: Kubernetes,
  VM
}

export const AgentPlatformIcon = ({
  platform,
  ...props
}: IconProps & { platform: InventoryPlatformAi }) => {
  const Icon = AGENT_PLATFORM_ICONS[platform]

  return <Icon {...props} />
}
